import EditButton from "./EditButton";

EditButton.install = function(Vue) {
  Vue.component(EditButton.name, EditButton);
};

export default EditButton;
